import React, { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { uploadImage, img } from "../lib/api";
import { toast } from "../hooks/use-toast";

// Reusable image uploader. Calls onUpload(url) with the stored media URL.
const ImageUpload = ({ value, onUpload, onClear, label = "Upload image", compact = false }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = () => ref.current?.click();

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const res = await uploadImage(file);
      onUpload(res.url);
    } catch (err) {
      toast({ title: "Upload failed", description: "Please try a smaller image (max 8MB)." });
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <div className={compact ? "flex items-center gap-3" : ""}>
      <input ref={ref} type="file" accept="image/*" onChange={handle} className="hidden" />
      {value ? (
        <div className="flex items-center gap-3">
          <img src={img(value)} alt="preview" className="h-14 w-14 rounded-lg object-cover border border-white/15" />
          <button type="button" onClick={pick} disabled={busy} className="text-sm text-gold hover:underline inline-flex items-center gap-1">
            {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />} Replace
          </button>
          {onClear && (
            <button type="button" onClick={onClear} className="text-slate-400 hover:text-red-400"><X size={16} /></button>
          )}
        </div>
      ) : (
        <button type="button" onClick={pick} disabled={busy} className="inline-flex items-center gap-2 text-sm border border-gold/30 hover:border-gold text-white px-3 py-2 rounded-lg transition-colors disabled:opacity-60">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Upload size={15} />} {label}
        </button>
      )}
    </div>
  );
};

export default ImageUpload;
